import documentAttribute from "./documentAttribute"
export default documentAttribute;
